<ll-titulo>Noticia #{{ noticiaId }}</ll-titulo>
<ll-toolnavbar>
    <noticia-toolnavbar [displayButtons]="'edit,all'" [noticiaId]="noticiaId"></noticia-toolnavbar>
</ll-toolnavbar>

<noticia [noticiaId]="noticiaId"></noticia>
